import React, { forwardRef } from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import { Accordion, Card } from 'react-bootstrap';

// LOCAL VARIABLES
import { PLACEHOLDER } from '../../variables';

// LOCAL COMPONENTS
import ListCardBody from './ListCardBody';
import ListCardHeader from './ListCardHeader';

// STYLES
import styles from './listCardCollapse.module.scss';

const ListCardCollapse = forwardRef(
  (
    {
      columns, //
      index,
      previewKeys,
      placeholder = PLACEHOLDER,
      style = {},
      ...props
    },
    ref
  ) => {
    return (
      <Accordion key={index} ref={ref} style={style}>
        <Card className={clsx('mb-3 border', styles.card)}>
          <ListCardHeader
            {...props} //
            index={index}
            previewKeys={previewKeys}
            columns={columns}
          />
          <Accordion.Collapse eventKey="0" className={styles.collapse}>
            <ListCardBody
              {...props} //
              columns={columns}
              placeholder={placeholder}
              rowNumber={index + 1}
            />
          </Accordion.Collapse>
        </Card>
      </Accordion>
    );
  }
);

// EXPORT
export default ListCardCollapse;
